import axios from 'axios';

export default class MultiSafepayService {
    /**
     * Get an API token.
     *
     * @param {string} profile
     * @return {AxiosPromise<any>}
     */
    static getApiToken(profile) {
        return axios.post(this.endpoint() + '/msp/api-token', {
            'profile': profile,
        });
    }

    /**
     * Get endpoint of API.
     *
     * @return {string}
     */
    static endpoint() {
        return 'payments';
    }
}
